import { getVenueCoverImage } from 'utils/shared/venues';
import { getAccessSummary } from '../../constants';
import type { ClubProfile } from '../../types';
import AddressRow from './AddressRow';
import AmenitiesList from './AmenitiesList';
import ClubIdentity from './ClubIdentity';
import ContactCard from './ContactCard';
import CoverBanner from './CoverBanner';

interface Props {
  venue: ClubProfile;
}

export default function ClubProfileAside({ venue }: Props) {
  const amenities = venue.amenities.map((entry) => entry.amenity);
  const customAmenities = venue.customAmenities.map((entry) => entry.name);
  const coverImage = getVenueCoverImage(venue.images);

  return (
    <aside className="flex flex-col gap-6">
      <CoverBanner imageUrl={coverImage?.url} clubName={venue.title} />

      <ClubIdentity
        clubName={venue.title}
        accessSummary={getAccessSummary(venue.facilityType, venue.accessType)}
        hasTennis={venue.hasTennis}
        hasPickleball={venue.hasPickleball}
        hasPadel={venue.hasPadel}
      />

      {venue.addressString && <AddressRow address={venue.addressString} />}

      <AmenitiesList amenities={amenities} customAmenities={customAmenities} />

      <ContactCard
        websiteUrl={venue.websiteUrl}
        email={venue.email}
        phoneNumber={venue.phoneNumber}
        instagramUrl={venue.instagramUrl}
        facebookUrl={venue.facebookUrl}
        youtubeUrl={venue.youtubeUrl}
        linkedinUrl={venue.linkedinUrl}
        twitterUrl={venue.twitterUrl}
      />
    </aside>
  );
}
